import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-29ab3305")

_pushScopeId("data-v-29ab3305")
const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex alignC top-button-group" }
const _hoisted_3 = { class: "c-ff" }
const _hoisted_4 = { class: "mar-t-12" }
const _hoisted_5 = { class: "mar-l-12 mar-t-12" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "f-28 mar-r-16" }, "状态", -1)
const _hoisted_7 = {
  key: 1,
  class: "mar-t-12"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "f-28 mar-r-16" }, "出库类型", -1)
const _hoisted_9 = {
  key: 2,
  class: "mar-t-12"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "f-28 mar-r-16" }, "入库类型", -1)
const _hoisted_11 = {
  key: 0,
  class: "flex button-group flexC"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "修改", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "作废", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "审核", -1)
const _hoisted_15 = {
  key: 1,
  class: "flex button-group flexC"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "反审核", -1)
const _hoisted_17 = {
  key: 2,
  class: "flex button-group flexC"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "恢复", -1)
const _hoisted_19 = { class: "flex flexR mar-t-22" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("报价锁定")
const _hoisted_21 = { class: "c-30" }
const _hoisted_22 = { class: "c-30" }
const _hoisted_23 = { class: "dialog-footer" }
const _hoisted_24 = { class: "c-ff" }
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "取 消", -1)
const _hoisted_26 = {
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      ((_ctx.type=='1' && _ctx.roleList.create) || (_ctx.type=='2' && _ctx.roleList.create))
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            class: "bg-red mar-r-18 mar-t-12",
            onClick: _ctx.createBill
          }, {
            default: _withId(() => [
              _createVNode("span", _hoisted_3, "新增" + _toDisplayString(_ctx.type == "1" ? "出" : "入") + "库单", 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_el_select, {
          class: "mar-r-8",
          style: {"width":"108px"},
          modelValue: _ctx.screenParameter.time_type,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.screenParameter.time_type = $event)),
          placeholder: "请选择",
          clearable: "",
          onChange: _ctx.screenChange
        }, {
          default: _withId(() => [
            _createVNode(_component_el_option, {
              label: "制单日期",
              value: "1"
            }),
            _createVNode(_component_el_option, {
              label: "审核日期",
              value: "2"
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"]),
        _createVNode(_component_el_date_picker, {
          modelValue: _ctx.selectGroup.time,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectGroup.time = $event)),
          type: "daterange",
          align: "right",
          "unlink-panels": "",
          "range-separator": "-",
          "start-placeholder": "开始日期",
          "end-placeholder": "结束日期",
          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectChange($event, 'time')))
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_el_select, {
          class: "mar-r-8",
          style: {"width":"108px"},
          modelValue: _ctx.screenParameter.status,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.screenParameter.status = $event)),
          placeholder: "请选择",
          clearable: "",
          onChange: _ctx.screenChange
        }, {
          default: _withId(() => [
            _createVNode(_component_el_option, {
              label: "待审核",
              value: "0"
            }),
            _createVNode(_component_el_option, {
              label: "已审核",
              value: "1"
            }),
            _createVNode(_component_el_option, {
              label: "已作废",
              value: "2"
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"])
      ]),
      (_ctx.type == '1')
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_el_select, {
              class: "mar-r-8",
              style: {"width":"108px"},
              modelValue: _ctx.screenParameter.type,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.screenParameter.type = $event)),
              placeholder: "请选择",
              clearable: "",
              onChange: _ctx.screenChange
            }, {
              default: _withId(() => [
                _createVNode(_component_el_option, {
                  label: "领料出库",
                  value: "0"
                }),
                _createVNode(_component_el_option, {
                  label: "盘亏出库",
                  value: "3"
                }),
                _createVNode(_component_el_option, {
                  label: "辅料领料出库",
                  value: "1"
                }),
                _createVNode(_component_el_option, {
                  label: "退货出库",
                  value: "4"
                }),
                _createVNode(_component_el_option, {
                  label: "配件销售出库",
                  value: "5"
                }),
                _createVNode(_component_el_option, {
                  label: "其它出库",
                  value: "2"
                })
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.type == '2')
        ? (_openBlock(), _createBlock("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_el_select, {
              class: "mar-r-8",
              style: {"width":"108px"},
              modelValue: _ctx.screenParameter.type,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.screenParameter.type = $event)),
              placeholder: "请选择",
              clearable: "",
              onChange: _ctx.screenChange
            }, {
              default: _withId(() => [
                _createVNode(_component_el_option, {
                  label: "采购入库",
                  value: "4"
                }),
                _createVNode(_component_el_option, {
                  label: "退料入库",
                  value: "0"
                }),
                _createVNode(_component_el_option, {
                  label: "盘盈入库",
                  value: "3"
                }),
                _createVNode(_component_el_option, {
                  label: "辅料退料入库",
                  value: "1"
                }),
                _createVNode(_component_el_option, {
                  label: "其它入库",
                  value: "2"
                })
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_input, {
        style: {"width":"202px"},
        modelValue: _ctx.screenParameter.search,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.screenParameter.search = $event)),
        placeholder: _ctx.type == '1'?'单据编号/配件/车牌号':'单据编号/配件/供应商',
        clearable: "",
        "suffix-icon": "el-icon-search",
        onChange: _ctx.screenChange,
        class: "mar-t-12"
      }, null, 8, ["modelValue", "placeholder", "onChange"])
    ]),
    _withDirectives(_createVNode(_component_el_table, {
      data: _ctx.tableData,
      stripe: "",
      style: {"width":"100%"},
      class: "table",
      "header-cell-style": _ctx.headClass
    }, {
      default: _withId(() => [
        _createVNode(_component_el_table_column, {
          label: "单据编号",
          align: "center",
          "min-width": "164"
        }, {
          default: _withId((scope) => [
            _createVNode("div", {
              class: "c-red purchaes_number",
              onClick: ($event: any) => (_ctx.bindPurchaseInfo(scope.row.id))
            }, _toDisplayString(scope.row.record_code), 9, ["onClick"])
          ]),
          _: 1
        }),
        (_ctx.type == '1')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              align: "center",
              prop: "car_name",
              label: "车牌",
              "min-width": "90"
            }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            align: "center",
            prop: item.prop,
            label: item.label,
            "min-width": item.width,
            key: index
          }, null, 8, ["prop", "label", "min-width"]))
        }), 128)),
        _createVNode(_component_el_table_column, {
          label: "操作",
          align: "center",
          "min-width": "120"
        }, {
          default: _withId((scope) => [
            (scope.row.status == 0)
              ? (_openBlock(), _createBlock("div", _hoisted_11, [
                  ((_ctx.type == '1' || (_ctx.type=='2' && scope.row.type!=4)) && _ctx.roleList.edit)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        onClick: ($event: any) => (_ctx.changeClick(scope.row))
                      }, {
                        default: _withId(() => [
                          _hoisted_12
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  ((_ctx.type=='1' && _ctx.roleList.void) || (_ctx.type=='2' && _ctx.roleList.void))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        onClick: ($event: any) => (_ctx._libraryUps(scope.row.id, 2))
                      }, {
                        default: _withId(() => [
                          _hoisted_13
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  ((_ctx.type=='1' && _ctx.roleList.check) || (_ctx.type=='2' && _ctx.roleList.check))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 2,
                        onClick: ($event: any) => (_ctx._libraryUps(scope.row.id, 1))
                      }, {
                        default: _withId(() => [
                          _hoisted_14
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]))
              : (scope.row.status == 1)
                ? (_openBlock(), _createBlock("div", _hoisted_15, [
                    ((_ctx.type=='1' && _ctx.roleList.recheck) || (_ctx.type=='2' && _ctx.roleList.recheck))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          onClick: ($event: any) => (_ctx._libraryUps(scope.row.id, 3))
                        }, {
                          default: _withId(() => [
                            _hoisted_16
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_17, [
                    ((_ctx.type=='1' && _ctx.roleList.recovery) || (_ctx.type=='2' && _ctx.roleList.recovery))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          onClick: ($event: any) => (_ctx._libraryUps(scope.row.id, 4))
                        }, {
                          default: _withId(() => [
                            _hoisted_18
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "header-cell-style"]), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode("div", _hoisted_19, [
      _createVNode(_component_el_pagination, {
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.currentPage,
        "page-sizes": [10, 20,50,100],
        "page-size": _ctx.pageSize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      title: _ctx.dialogTitle,
      modelValue: _ctx.dialogFormVisible,
      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.dialogFormVisible = $event)),
      center: "",
      width: 1000
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_23, [
          _createVNode(_component_el_button, {
            class: "bg-red",
            onClick: _ctx.submitForm
          }, {
            default: _withId(() => [
              _createVNode("span", _hoisted_24, _toDisplayString(_ctx.isEdit ? "保存" : "立即创建"), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.dialogFormVisible = false))
          }, {
            default: _withId(() => [
              _hoisted_25
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_el_form, {
          model: _ctx.form,
          rules: _ctx.rules,
          ref: "formRef",
          inline: true
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              class: "width-40",
              label: "配件名称",
              prop: "name",
              "label-width": "100px"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  class: "dialog-input",
                  modelValue: _ctx.form.name,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.name = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "配件分类",
              "label-width": "100px",
              prop: "mountings_type_pid"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  class: "mar-r-18 dialog-input",
                  modelValue: _ctx.form.mountings_type_pid,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.mountings_type_pid = $event)),
                  placeholder: "请选择",
                  onChange: _ctx.formSelectChange
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.mountings_ptype_data, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.name,
                        value: item.id,
                        key: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"]),
                _createVNode(_component_el_select, {
                  class: "dialog-input",
                  modelValue: _ctx.form.mountings_type_id,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.mountings_type_id = $event)),
                  placeholder: "请选择",
                  disabled: !_ctx.form.mountings_type_pid
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.mountings_type_data, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.name,
                        value: item.id,
                        key: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "width-40",
              label: "成本价",
              prop: "cost_price",
              "label-width": "100px"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  class: "dialog-input",
                  modelValue: _ctx.form.cost_price,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.cost_price = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "销售价",
              "label-width": "100px"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  class: "dialog-input mar-r-8",
                  modelValue: _ctx.form.selling_price,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.form.selling_price = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withId(() => [
                _createVNode(_component_el_radio, {
                  onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (
                            _ctx.form.price_lock = _ctx.form.price_lock == 1 ? 0 : 1
                        ), ["prevent"])),
                  modelValue: _ctx.form.price_lock,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.form.price_lock = $event)),
                  label: 1
                }, {
                  default: _withId(() => [
                    _hoisted_20
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "width-40",
              label: "配件品牌",
              "label-width": "100px"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  class: "dialog-input",
                  modelValue: _ctx.form.mountings_brand_id,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.form.mountings_brand_id = $event)),
                  filterable: "",
                  placeholder: "请选择",
                  remote: "",
                  "remote-method": _ctx.remoteBrand,
                  loading: _ctx.remote_loading,
                  onBlur: _cache[16] || (_cache[16] = ($event: any) => (_ctx.brandBlur(false)))
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.mountings_brand_data, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.name,
                        value: item.id,
                        key: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "remote-method", "loading"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "规格",
              "label-width": "100px"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  class: "dialog-input",
                  modelValue: _ctx.form.specification,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.form.specification = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "width-40",
              label: "单位",
              "label-width": "100px"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  class: "dialog-input",
                  modelValue: _ctx.form.unit_id,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.form.unit_id = $event)),
                  placeholder: "请选择",
                  clearable: ""
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.mountings_unit_data, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.name,
                        value: item.id,
                        key: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "width-40",
              label: "编码",
              "label-width": "100px"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  class: "dialog-input",
                  modelValue: _ctx.form.encoding,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.form.encoding = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "施工提成",
              "label-width": "100px",
              class: "width-40"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  class: "dialog-select-min",
                  modelValue: _ctx.form.build_bonus_type,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.form.build_bonus_type = $event)),
                  placeholder: "请选择",
                  onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.bonusSelectChange(true)))
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.commissionType, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item,
                        value: index + 1,
                        key: index
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_input, {
                  class: "dialog-input-min",
                  modelValue: _ctx.form.build_bonus_price,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.form.build_bonus_price = $event))
                }, {
                  suffix: _withId(() => [
                    _createVNode("span", _hoisted_21, _toDisplayString(_ctx.form.build_bonus_type == 1 ? "元" : "%"), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "销售提成",
              "label-width": "100px",
              class: "width-40"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  class: "dialog-select-min",
                  modelValue: _ctx.form.sell_bonus_type,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.form.sell_bonus_type = $event)),
                  placeholder: "请选择",
                  onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.bonusSelectChange(false)))
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.commissionType, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item,
                        value: index + 1,
                        key: index
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_input, {
                  class: "dialog-input-min",
                  modelValue: _ctx.form.sell_bonus_price,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.form.sell_bonus_price = $event))
                }, {
                  suffix: _withId(() => [
                    _createVNode("span", _hoisted_22, _toDisplayString(_ctx.form.sell_bonus_type == 1 ? "元" : "%"), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "width-full",
              label: "返现方案",
              "label-width": "100px"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  class: "dialog-input",
                  modelValue: _ctx.form.return_cash_plan,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.form.return_cash_plan = $event)),
                  placeholder: "请选择"
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.reappearance_type_data, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.reappearance_type_name,
                        value: item.reappearance_type_id,
                        key: item.reappearance_type_id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "width-full",
              label: "描述",
              "label-width": "100px"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  class: "dialog-input",
                  modelValue: _ctx.form.describe,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.form.describe = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "工单详情",
      modelValue: _ctx.detaildia_show,
      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.detaildia_show = $event)),
      onClosed: _ctx.handleClose,
      center: "",
      width: 1000
    }, {
      default: _withId(() => [
        _createVNode("table", _hoisted_26, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailTable, (items, index) => {
            return (_openBlock(), _createBlock("tr", { key: index }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(items, (item, idx) => {
                return (_openBlock(), _createBlock("td", { key: idx }, _toDisplayString(item), 1))
              }), 128))
            ]))
          }), 128))
        ]),
        (_ctx.isMountings)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 0,
              data: _ctx.purchaseDetail.parts_list,
              stripe: "",
              style: {"width":"100%"},
              class: "mar-b-10",
              "show-summary": "",
              "summary-method": (item) => _ctx.getSummaries(item, 1),
              "header-cell-style": _ctx.headClass
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.purchaseColumn, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    align: "center",
                    prop: item.prop,
                    label: (index==6&&_ctx.type==1)?'成本价':item.label,
                    "min-width": item.width,
                    key: index
                  }, null, 8, ["prop", "label", "min-width"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "summary-method", "header-cell-style"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onClosed"])
  ]))
})